import { Icon } from "@evergis/ui";
import { Flex } from "grid-styled";
import styled from "styled-components";

export const EmptyLayerListContainer = styled(Flex)`
  margin: auto;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-left: 4.5rem;
  padding-right: 4.5rem;
`;

export const EmptyLayerListIcon = styled(Icon)`
  height: 2rem;
  width: 2rem;
  line-height: 1rem;
  opacity: 0.12;
  &:after {
    font-size: 2rem;
  }
`;

export const EmptyLayerListTitle = styled.div`
  opacity: 0.87;
  font-size: 1rem;
  margin-top: 1.5rem;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const EmptyLayerListDescription = styled.div`
  font-size: 0.75rem;
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;
